<template>
<v-container grid-list-md>
    <v-layout column>
        <v-radio-group v-model="displayValueTypeCode" row class="align-center justify-center">
            <v-radio v-for="(valueTypeCode, i) in valueTypeCodes" :key="`valueTypeCode${i}`" :label="valueTypeCode.text" :value="valueTypeCode.value"></v-radio>
            <v-btn flat icon color="green" @click="$emit('refresh')" class="align-center justify-center">
                <v-icon>cached</v-icon>
            </v-btn>
        </v-radio-group>        
        <v-layout row wrap align-center justify-space-around>
            <v-flex xs12 px-1>
                <crop-profile-graph ref="cropProfileGraph"
                    :financialYearCalendars="financialYearCalendarData"
                    :cropProfile="variety.activeProfile"
                    :cropForecasts="forecasts"                    
                    :displayValueTypeCode="displayValueTypeCode"
                    :loading="loading">
                </crop-profile-graph>
            </v-flex>
        </v-layout>
    </v-layout>
</v-container>
</template>

<script>

import CropProfileGraph from '@/components/crops/CropProfileGraph.vue';

import { mapState } from "vuex"

export default {
    components: {
        CropProfileGraph
    },
    props: {
        variety: {
            type: Object,
            required: true
        },
        forecasts: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    data(){
        return {
            displayValueTypeCode: "kg",
            valueTypeCodes: [
                {
                    text: "Percentage (%)",
                    value: "%"
                }, 
                {
                    text: "Kilograms (kg)",
                    value: "kg"
                }
            ],
        };
    },
    computed: {
        ...mapState("ForecastingStore", [
            "financialYearCalendarData"
        ])
    },
    methods: {

    },
    created(){
        
    }
}
</script>